import { X } from 'lucide-react';
import { format } from 'date-fns';
import { formatAddress } from '../../utils/subscriptionUtils';
import { formatPrice } from '../../utils/priceFormat';

interface CancelledSubscriptionModalProps {
  subscription: any;
  isOpen: boolean;
  onClose: () => void;
}

const CancelledSubscriptionModal: React.FC<CancelledSubscriptionModalProps> = ({
  subscription,
  isOpen,
  onClose
}) => {
  if (!isOpen || !subscription) return null;
  
  // Convert day number to day name if available
  const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const dayName = subscription.schedule?.dayOfWeek !== undefined 
    ? dayNames[subscription.schedule.dayOfWeek] 
    : '';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl p-6 w-full max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold">
            {subscription.plan === 'premium' ? 'Premium' : 'Standard'} Plan Details
            {subscription.isGift && ' (Gift)'}
          </h3>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        
        <div className="space-y-4">
          <div className="bg-gray-50 p-4 rounded-lg">
            <p className="text-red-500 font-medium mb-2">Cancelled Subscription</p>
            {subscription.startDate && (
              <p className="text-sm text-gray-600">
                Start date: {format(new Date(subscription.startDate), 'MMMM d, yyyy')}
              </p>
            )}
            {subscription.endDate && (
              <p className="text-sm text-gray-600">
                End date: {format(new Date(subscription.endDate), 'MMMM d, yyyy')}
              </p>
            )}
            {subscription.price && (
              <p className="text-sm text-gray-600">
                Price: ${formatPrice(subscription.price, 'usd')} per delivery
              </p>
            )}
          </div>
          
          {subscription.address && (
            <div className="bg-gray-50 p-4 rounded-lg">
              <h4 className="font-medium mb-2">Delivery Address</h4>
              <p className="text-sm text-gray-600">
                {formatAddress(subscription.address)}
              </p>
            </div>
          )}
          
          {subscription.schedule && (
            <div className="bg-gray-50 p-4 rounded-lg">
              <h4 className="font-medium mb-2">Delivery Schedule</h4>
              {dayName && (
                <p className="text-sm text-gray-600">
                  Day: {dayName} 
                </p>
              )}
              {subscription.schedule.timeSlot && (
                <p className="text-sm text-gray-600">
                  Time slot: {subscription.schedule.timeSlot}
                </p>
              )}
            </div>
          )}
        </div>
        
        <button
          onClick={onClose}
          className="w-full mt-6 bg-gray-100 text-gray-800 font-medium py-3 rounded-lg"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default CancelledSubscriptionModal; 